import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit} from '@angular/core';
import {CurrencyAmount} from '../../../../domain/currency-amount';
import {Side} from '../../../../domain/side';
import {TradingRatePipe} from '../../../../pipes/rate/trading-rate';
import {InsightsViewType} from '../../../../domain/insights-view-type';
import {DecimalAmountPipe} from '../../../../pipes/decimal-input/decimal-input.pipe';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-bar-chart-side-card',
  imports: [IonicModule, TradingRatePipe, DecimalAmountPipe, TranslateModule],
  templateUrl: './bar-chart-side-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./bar-chart-side-card.component.scss']
})
export class BarChartSideCardComponent implements OnInit, OnChanges {
  readonly TradingRatePipe = TradingRatePipe;
  readonly DecimalAmountPipe = DecimalAmountPipe;

  @Input() tradingCurrency: CurrencyAmount;
  @Input() contraCurrency: CurrencyAmount;
  @Input() averageRate: number;
  @Input() viewType: InsightsViewType;

  tradingCcyBuySide = false;
  contraCcyBuySide = false;
  isNetPosition: boolean;

  ngOnChanges(): void {
    this.isNetPosition = this.viewType === InsightsViewType.NET_AMOUNTS;
  }

  ngOnInit(): void {
    this.isNetPosition = this.viewType === InsightsViewType.NET_AMOUNTS;
    this.tradingCurrency.side === Side.BUY ? this.tradingCcyBuySide = true : this.tradingCcyBuySide = false;
    this.contraCurrency.side === Side.BUY ? this.contraCcyBuySide = true : this.contraCcyBuySide = false;
  }
}
